import { RootState } from '../../../../stores/store';

export const cropListSelector = (state: RootState) => state.listOfCrops;
export const insectListSelector = (state: RootState) => state.insectsList;
